/** Kürzt Text für Meta-Descriptions auf max. 155 Zeichen (an Wortgrenze) */
export function metaDescription(text: string | null | undefined, max = 155): string {
  const clean = (text ?? '').replace(/\s+/g, ' ').trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  return `${cut.slice(0, cut.lastIndexOf(' ') > 80 ? cut.lastIndexOf(' ') : cut.length)}…`;
}

/** true während react-snap die Seite vorrendert */
export const isPrerendering = (): boolean =>
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

/** <img fetchpriority="high"> – React 18 kennt die camelCase-Variante noch nicht, daher als Attribut */
export const HIGH_PRIORITY = { fetchpriority: 'high' } as Record<string, string>;
